export const NAME = 'directory';

export const DEFAULT_SORT = { id: -1, name: '--' };
export const CASHBACK_SORT = { id: 0, name: 'Cashback' };
export const NOM_SORT = { id: 1, name: 'Nom' };
export const LESPLUSPOPULAIRES_SORT = { id: 2, name: 'Les + populaires' };
export const NOUVEAUTES_SORT = { id: 3, name: 'Nouveautés' };
export const NBCOUPON_SORT = { id: 4, name: 'Nombre de coupons' };
export const CASHBACK_OFFLINE_SORT = { id: 5, name: 'Cashback' };
export const CASHBACK_EBON_SORT = { id: 6, name: 'Cashback' };

export const ABCBOOK_DEFAULT_LETTER = '123';

export const ASC = 'asc';
export const DESC = 'desc';

export const NB_AFFICHAGE_GRILLE = 16;

/**
 * Here goes the actionTypes
 */

export const CHANGE_CURRENT_FILTER = 'CHANGE_CURRENT_FILTER';
export const RESET_FILTER = 'RESET_FILTER';



// WEBPACK FOOTER //
// ./src/services/directory/constants.js